module.exports = __webpack_public_path__ + "static/media/2.15f732a9.png";